module.exports = __webpack_public_path__ + "static/media/XXVIIIe.3dd7bd66.png";